async function ExportCSV() {
  var title = ["カテゴリー", "品番", "種類", "特徴", "個数"];
  var str = "";

  // ヘッダー末尾にカンマが付かないよう join を使用
  str += title.join(",");
  str += "\n";
  str += csvData;
  str += "\n";
  str += "＊AIアプリの数量には、AIアプリのライセンス数が表示されます。";
  str += "\n";
  str += "";

  // 現在時刻 例）2023-01-01 11:11:11
  const date = new Date();
  const currentDate = `${date.getFullYear()}${("00" + (date.getMonth() + 1)).slice(-2)}${(
    "00" + date.getDate()
  ).slice(-2)}`;

  var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  var blob = new Blob([bom, str], { type: "text/csv" }); //配列に上記の文字列(str)を設定
  var link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `見積商品_${currentDate}.csv`;
  link.click();
}
